export enum ToolName {
  CROP = 'crop',
  RESIZE = 'resize',
  FILTER = 'filter',
  TRANSFORM = 'transform',

  DRAW = 'draw',
  TEXT = 'text',
  SHAPES = 'shapes',
  STICKERS = 'stickers',
  CORNERS = 'corners',
}
